export function resetForm (refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}



// WEBPACK FOOTER //
// ./src/utils/form.js